export const BASE_URL = `https://legal-companion-backend.onrender.com`;
// export const BASE_URL = `http://localhost:5000`;
